import React, { useState } from "react";
import { Heart, CheckCircle2, MessageCircle, ChevronRight } from "lucide-react";
import { colors, themeOf } from "@/lib/theme";
import { dayNum, monthAbbr, formatTime } from "@/lib/date";
import { FriendsGoing } from "@/components/peeps/FriendsGoing";

export function AgendaItem({ item, onClick }) {
  const th = themeOf(item.group?.theme);
  const [showGroups, setShowGroups] = useState(false);
  const groupNames = item.group_names || [];
  return (
    <div
      data-testid={`agenda-${item.id}`}
      onClick={onClick}
      className="flex items-center gap-3 rounded-xl p-2 pr-3 cursor-pointer transition-all hover:border-[#4A4B5C]"
      style={{ background: colors.surfaceSecondary, border: `1px solid ${colors.border}` }}
    >
      <div className="flex flex-col items-center justify-center rounded-md shrink-0" style={{ width: 46, height: 52, background: th.solid }}>
        <span className="font-mono2 font-bold text-[9px] tracking-widest" style={{ color: th.on }}>{monthAbbr(item.date)}</span>
        <span className="font-mono2 font-bold text-[19px] leading-[21px]" style={{ color: th.on }}>{dayNum(item.date)}</span>
      </div>
      <div className="flex-1 min-w-0 flex flex-col gap-[3px]">
        <div className="flex items-center justify-between gap-2">
          <h3 className="flex-1 font-display font-bold text-[14.5px] truncate" style={{ color: colors.onSurface }}>{item.title}</h3>
          {item.im_going && (
            <span className="flex items-center gap-[3px] py-0.5 px-[7px] rounded-full shrink-0" style={{ background: colors.success + "22" }}>
              <CheckCircle2 size={11} color={colors.success} />
              <span className="font-display font-medium text-[10px]" style={{ color: colors.success }}>Going</span>
            </span>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          <span className="rounded-full py-0.5 px-2 truncate max-w-[120px]" style={{ background: th.solid + "22" }}>
            <span className="font-display font-medium text-[10.5px]" style={{ color: th.solid }}>{item.group?.name}</span>
          </span>
          {item.group_count > 1 && (
            <button
              data-testid={`agenda-groupcount-${item.id}`}
              onClick={(e) => { e.stopPropagation(); setShowGroups((v) => !v); }}
              className="rounded-full py-0.5 px-2 shrink-0 transition-colors"
              style={{ background: colors.surfaceTertiary }}
            >
              <span className="font-display font-medium text-[10.5px]" style={{ color: colors.onSurfaceTertiary }}>In {item.group_count} groups</span>
            </button>
          )}
          {item.is_multi_day && (
            <span data-testid={`agenda-multiday-${item.occ_id || item.id}`} className="rounded-full py-0.5 px-2 shrink-0" style={{ background: th.solid + "22" }}>
              <span className="font-display font-medium text-[10.5px]" style={{ color: th.solid }}>Day {item.span_day} of {item.span_len}</span>
            </span>
          )}
          <span className="flex-1 font-display text-[11.5px] truncate" style={{ color: colors.onSurfaceTertiary }}>
            {formatTime(item.time)}{item.end_time ? ` – ${formatTime(item.end_time)}` : ""}{item.location ? ` · ${item.location}` : ""}
          </span>
        </div>
        {showGroups && groupNames.length > 0 && (
          <div data-testid={`agenda-groups-expanded-${item.id}`} className="flex flex-wrap gap-1 mt-1">
            {groupNames.map((n) => (
              <span key={n} className="rounded-full py-0.5 px-2" style={{ background: th.solid + "22" }}>
                <span className="font-display font-medium text-[10px]" style={{ color: th.solid }}>{n}</span>
              </span>
            ))}
          </div>
        )}
        <div className="flex items-center gap-2.5">
          <span className="flex items-center gap-[3px]"><Heart size={11} color={colors.muted} /><span className="font-mono2 font-medium text-[10.5px]" style={{ color: colors.muted }}>{item.vote_count}</span></span>
          <span className="flex items-center gap-[3px]"><CheckCircle2 size={11} color={colors.muted} /><span className="font-mono2 font-medium text-[10.5px]" style={{ color: colors.muted }}>{item.going_count}</span></span>
          <span className="flex items-center gap-[3px]"><MessageCircle size={10} color={colors.muted} /><span className="font-mono2 font-medium text-[10.5px]" style={{ color: colors.muted }}>{item.comment_count || 0}</span></span>
          {item.commented && <span className="font-display text-[10.5px]" style={{ color: colors.faint }}>· you commented</span>}
          {item.source === "chat_import" && item.source_label && (
            <span className="font-display text-[10px] truncate" style={{ color: "#F0C060" }}>· {item.source_label}</span>
          )}
        </div>
        {(item.friends_going_count ?? 0) > 0 && (
          <div className="mt-0.5"><FriendsGoing friends={item.friends_going} compact size={16} /></div>
        )}
      </div>
      <ChevronRight size={16} color={colors.muted} />
    </div>
  );
}
